import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isChecked: true,
    pageerror: '',
    emailerror: '',
    otperror: '',
    uanerror: '',
    emailsuccess: '',
    emailsent: '',
    verificationType: null,
    emailAddress: null,
    otp: null,
    uan: null,
    isErrorModalOpen: false
};

const employmentSlice = createSlice({
    name: 'employment',
    initialState,
    reducers: {
        setIsChecked(state, action) {
            state.isChecked = action.payload;
        },
        setPageError(state, action) {
            state.pageerror = action.payload;
        },
        setEmailError(state, action) {
            state.emailerror = action.payload;
        },
        setOTPError(state, action) {
            state.otperror = action.payload;
        },
        setUANError(state, action) {
            state.uanerror = action.payload;
        },
        setEmailSuccess(state, action) {
            state.emailsuccess = action.payload;
        },
        setEmailSent(state, action) {
            state.emailsent = action.payload;
        },
        setVerificationType(state, action) {
            state.verificationType = action.payload;
        },
        setEmailAddress(state, action) {
            state.emailerror = ''
            state.otperror = ''
            state.pageerror = ''
            state.uanerror = ''
            state.emailsuccess = ''
            state.verificationType = ''
            state.emailAddress = action.payload;
        },
        setOTP(state, action) {
            state.emailerror = ''
            state.otperror = ''
            state.pageerror = ''
            state.uanerror = ''
            state.otp = action.payload;
        },
        setUAN(state, action) {
            state.emailerror = ''
            state.otperror = ''
            state.pageerror = ''
            state.uanerror = ''
            state.uan = action.payload;
        },
        openErrorModal: (state) => {
            state.isErrorModalOpen = true;
        },
        closeErrorModal: (state) => {
            state.isErrorModalOpen = false;
        },
    },
});

export const { setIsChecked, setPageError, setEmailError, setOTPError, setUANError, setEmailSuccess, setEmailSent, setVerificationType, setEmailAddress, setOTP, setUAN, openErrorModal, closeErrorModal } = employmentSlice.actions;

export default employmentSlice.reducer;
